export default function mobileApp({next}) {
  if (!(/nomad-lk-android-wv|nomad-lk-ios-wv/.test(navigator.userAgent.toLowerCase()))) {
    return next({
      name: 'dashboard'
    })
  }
  return next()
}
